<template>
    <b-modal v-model="modal_results.show"
             hide-footer
             centered
             size="lg"
             :title="'Mediciones higiénicas del GES - ' + hygienic_measurement.name "
    >
        <b-row>
            <b-col>
                <el-input size="small"
                          placeholder="Buscar"
                          v-model="params_results.filter"
                ></el-input>
            </b-col>

            <b-col>
                <b-button variant="primary"
                          @click="fetchResults(true)"
                          size="sm"
                >
                    <i class="fa fa-search"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Buscar'"
                    />
                </b-button>

                <b-button size="sm"
                          @click="resetParamsResult()"
                >
                    <i class="fa fa-eraser"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Limpiar'"
                    />
                </b-button>

                <b-button v-if="validarPermisoComponente('empresa-editar-ges')" variant="primary"
                          size="sm"
                          @click="openModalForCreation()"
                          class="float-right"
                >
                    <i class="fa fa-plus"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Crear'"
                    />
                </b-button>
            </b-col>
        </b-row>


        <b-table hover
                 striped
                 responsive
                 :fields="columns"
                 show-empty
                 empty-text="No hay mediciones higiénicas para mostrar"
                 :items="results.data"
                 class="mt-3"
        >
            <template v-if="validarPermisoComponente('empresa-editar-ges')" v-slot:cell(actions)="data">
                <el-tooltip popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Editar"
                >
                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="openModalForEdition(data.item)"
                    >
                        <i class="fa fa-edit"/>
                    </b-btn>
                </el-tooltip>

                <el-tooltip popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Eliminar"
                >
                    <b-btn variant="danger"
                           class="mx-1"
                           size="sm"
                           @click="deleteResult(data.item.id)"
                    >
                        <i class="fa fa-trash"/>
                    </b-btn>
                </el-tooltip>
            </template>
        </b-table>

        <!-- Paginación -->
        <el-pagination v-if="results.data && !!results.data.length"
                       v-model="params_results.page"
                       @size-change="fetchResults(true)"
                       @current-change="fetchResults()"
                       :current-page.sync="params_results.page"
                       class="float-right"
                       :page-size.sync="params_results.per_page"
                       :page-sizes="[10, 30, 50, 100]"
                       layout="total, sizes, prev, pager, next"
                       :total="results.total"
        />
    </b-modal>
</template>


<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    name: 'modal_results',
    data() {
        return {
            fields: [
                {
                    key: 'date',
                    label: 'Fecha',
                    thStyle: 'width: 200px; min-width: 200px',
                },
                {
                    key: 'result',
                    label: 'Resultado'
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                    thStyle: 'width: 120px',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    computed: {
        ...mapState('hygienic_measurements', [
            'results',
            'editing_result',
            'modal_results',
            'params_results',
            'hygienic_measurement'
        ]),
        columns() {
            const columnsBase = [
            {
                    key: 'date',
                    label: 'Fecha',
                    thStyle: 'width: 200px; min-width: 200px',
                },
                {
                    key: 'result',
                    label: 'Resultado'
                },
            ];

            if(this.validarPermisoComponente('empresa-editar-ges')) {
                columnsBase.push({
                    key: 'actions',
                    label: 'Acciones',
                    thStyle: 'width: 120px',
                    tdClass: 'text-nowrap text-right'
                });
            }

            return columnsBase;
        }
    },
    methods: {
        ...mapActions('hygienic_measurements', [
            'fetchCompanies',
            'fetchResults',
            'getResult',
            'deleteResult',
            'fetchPositions',
            'fetchResults'
        ]),
        ...mapMutations('hygienic_measurements', [
            'setShowToModalResult',
            'setShowToModalResults',
            'resetParams',
            'setEditingResult',
            'resetHygienicMeasurement',
            'setStepToModal',
            'setHygienicMeasurement',
            'setModalImage',
            'resetResult',
            'resetParamsResults'
        ]),
        async openModalForCreation() {
            this.resetResult();
            this.setEditingResult(false);
            this.setShowToModalResults(false);
            this.setShowToModalResult(true);
        },
        async openModalForEdition(result) {
            await this.getResult(result.id);
            this.setEditingResult(true);
            this.setShowToModalResults(false);
            this.setShowToModalResult(true);
        },
        async resetParamsResult() {
            this.resetParamsResults();
            this.fetchResults(true);
        }
    }
};
</script>
